import React from 'react'
import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import BackIcon from '@material-ui/icons/ArrowBackIos'
import Button from '../Button'
import Grid from '../Grid'
import { useTranslation } from '../../providers/TranslationProvider'

const useStyles = makeStyles<Theme, { hideDivider?: boolean }>((theme) => ({
  root: {
    padding: theme.spacing(1.5, 2),
    // borderTop:  `1px solid ${theme.palette.divider}`
    borderTop: ({ hideDivider }) => (hideDivider ? 'none' : `1px solid ${theme.palette.divider}`)
  },
  button: {
    transform: 'scale(0.9)'
  }
}))

export interface DropdownSelectFooterProps {
  onApply: () => void
  onClear: () => void
  clearLabel?: string
  doneLabel?: string
  hideDivider?: boolean
  hideDoneButton?: boolean
  doneButtonDisabled?: boolean
}

export default function DropdownSelectFooter({
  onApply,
  onClear,
  clearLabel,
  doneLabel,
  hideDivider,
  hideDoneButton,
  doneButtonDisabled
}: DropdownSelectFooterProps) {
  const classes = useStyles({ hideDivider })
  const { __ } = useTranslation()

  // If Done button is hidden and there's no Clear button, don't render footer
  const hasClearButton = clearLabel || onClear
  if (hideDoneButton && !hasClearButton) {
    return null
  }

  return (
    <Grid container className={classes.root} justifyContent={hideDoneButton ? 'flex-start' : 'space-between'}>
      {hasClearButton && (
        <Button
          icon={clearLabel === __('Back') ? BackIcon : null}
          className={classes.button}
          onClick={onClear}
          variant="textNoPadding"
        >
          {clearLabel || __('Clear')}
        </Button>
      )}
      {!hideDoneButton && (
        <Button className={classes.button} onClick={onApply} disabled={doneButtonDisabled}>
          {doneLabel || __('Done')}
        </Button>
      )}
    </Grid>
  )
}
